// @ts-nocheck
import CryptoJS from "crypto-js";
import sha256 from 'crypto-js/sha256';
import KeyCloak from "../Auth/Keycloak";
import { SECRET_KEY } from "../Contantes/Constantes";

const getUserInfo = () => {
    const hashUsername = sha256(KeyCloak.getUsername());
    if (localStorage.getItem(hashUsername)) return JSON.parse(decrypt(localStorage.getItem(hashUsername)));
    return {};
}

const setUserInfo = (userInfo) => {
    const hashUsername = sha256(KeyCloak.getUsername());
    localStorage.setItem(hashUsername, encrypt(JSON.stringify(userInfo)));
}


const menuItemsArray = ["noticias", "difusiones", "alias", "home", "ticketera", "recibos", "areas", 'altaUsuario', 'gestionUsuario', 'vpn', 'credencial', "archivos", "traducciones", "buscador_interno", /* "wifi", */"sueldos"];
// modulos son arrays de tuplas 
// ejemplo [[nombre,cantidadVistas],[nombre,cantidadVistas],[nombre,cantidadVistas]]
const getModulosInfo = () => {
    const hashUsername = sha256(KeyCloak.getUsername() + "modulo");
    if (localStorage.getItem(hashUsername)) {
        const modulosInfo = JSON.parse(decrypt(localStorage.getItem(hashUsername)));
        menuItemsArray.forEach(item => {
            if (!modulosInfo.find(modulo => modulo[0] === item)) modulosInfo.push([item, 0]);
        })
        return modulosInfo;
    }
    return menuItemsArray.map(item => [item, 0]);
}

const setModulosInfo = (modulosInfo) => {
    const hashUsername = sha256(KeyCloak.getUsername() + "modulo");
    localStorage.setItem(hashUsername, encrypt(JSON.stringify(modulosInfo)));
}

const addSystemView = (sistema) => {
    if (!KeyCloak.getUsername()) return;
    const userInfo = getUserInfo();

    if (userInfo[sistema.title]) userInfo[sistema.title] = userInfo[sistema.title] + 1;
    else userInfo[sistema.title] = 1;

    setUserInfo(userInfo);
}

const addNoticeView = (notice) => {
    if (!KeyCloak.getUsername()) return;
    const userInfo = getUserInfo();

    if (!userInfo.noticesViews) userInfo.noticesViews = [];

    if (!userInfo.noticesViews.includes(notice)) {
        userInfo.noticesViews.push(notice);
        setUserInfo(userInfo);
    }
}

const addMenuItemView = (menuItem) => {
    if (!KeyCloak.getUsername()) return;
    const modulosInfo = getModulosInfo();

    if (modulosInfo.find(modulo => modulo[0] === menuItem))
        modulosInfo.map(modulo => modulo[0] === menuItem ? [modulo[0], modulo[1]++] : modulo);
    else
        modulosInfo.push([menuItem, 1]);

    setModulosInfo(modulosInfo);
}

const getViewsNotices = () => {
    const userInfo = getUserInfo();
    return userInfo.noticesViews;
}

const encrypt = (string) => {
    return CryptoJS.AES.encrypt(string, SECRET_KEY).toString();
}

const decrypt = (string) => {
    const bytes = CryptoJS.AES.decrypt(string, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
}

const localStorageManagement = {
    getUserInfo,
    addSystemView,
    addNoticeView,
    getViewsNotices,
    addMenuItemView,
    getModulosInfo
};

export default localStorageManagement;
